<template>
  <section class="section--news" id="scrollToOnLoad" v-if="newsList.length">
    <b-container>
      <b-row class="news" v-if="!isMobile">
        <b-col sm="6" lg="5" xl="6">
          <div class="zoom-on-hover">
            <img class="news__photo"
              :src="domain + `${newsList[activeNewsIndex].photo}`" />
          </div>
        </b-col>
        <b-col sm="6" lg="5" xl="5" offset-lg="1"
        class="d-flex flex-column justify-content-center mt-4 mt-sm-0">
          <h2 class="news__title"> {{newsList[activeNewsIndex].title}} </h2>
          <p v-html="newsList[activeNewsIndex].body"></p>
        </b-col>
      </b-row>
      <b-row>
        <single-news v-for="(news, index) in newsList"
          :key="news.id" :news="news" :index="index" :activeNewsIndex="activeNewsIndex"
          @changeNews="changeActiveNews">
        </single-news>
      </b-row>
      <b-pagination v-scroll-to="'#scrollToOnLoad'"
        size="md" :total-rows="totalRows" v-model="page" :per-page="9">
      </b-pagination>
    </b-container>
  </section>
</template>

<script>
import news from '@/api/v1/news';
import { isMobile } from '@/utils/responsive';
import Hero from '@/components/Hero';
import SingleNews from '@/views/News/SingleNews';

export default {
  data() {
    return {
      bgImg: 'Banner4-News-',
      activeNewsIndex: 0,
      newsList: [],
      page: 1,
      isLast: true,
      isMobile,
      domain: process.env.SERVER_URL,
    };
  },
  components: {
    'section-hero': Hero,
    'single-news': SingleNews,
  },
  methods: {
    changeActiveNews(index) {
      this.activeNewsIndex = index;
    },

    getNews() {
      const page = this.page;
      const succ =
        (response) => {
          this.newsList = response.data.news;
          this.isLast = response.data.is_last;
        };
      news.index(page, succ);
    },
  },
  computed: {
    totalRows() {
      if (this.isLast) {
        return this.page * 9;
      }
      return (this.page + 1) * 9;
    },
  },
  created() {
    this.getNews();
  },
  watch: {
    page() {
      this.activeNewsIndex = 0;
      this.getNews();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./src/styles/helpers/_variables.scss";
@import "./src/styles/helpers/_include-media.scss";

.section--news {
  padding-bottom: 85px;
  padding-top: 100px;
  @include media("<sm") {
    padding: 40px 0;
  }
}
.news {
  padding-bottom: 90px;
  &__photo{
    width: 100%;
  }
  &__title {
    padding-left: 55px;
    padding-bottom: 38px;
    @include media("<lg") {
      padding-left: 0;
      padding-bottom: 0;
    }
  }
  &__img {
    height: 300px;
    background-size: cover;
    background-position: center;
    @include media("<lg") {
      height: 160px;
      margin-bottom: 10px;
    }
    @include media("<sm") {
      height: 250px;
      margin-bottom: 35px;
    }
  }
  &__wrapper {
    height: 432px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    text-align: center;
    margin-bottom: 20px;
    cursor: pointer;
    &--active {
      opacity: 0.5;
      @include media("<sm") {
        opacity: 1;
      }
    }
    @include media("<lg") {
      height: 260px;
    }
    @include media("<sm") {
      height: auto;
      margin-bottom: 40px;
    }
  }
  &__content {
    font-size: 16px;
    height: 75px;
    text-overflow: ellipsis;
    overflow: hidden;
    padding: 0 12px;
    margin: 0;
    @include media("<lg") {
      padding: 0 5px;
    }
    @include media("<sm") {
      padding-top: 10px;
      height: auto;
    }
  }
  &__button {
    margin-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/News/ListOfNews.vue